import React from 'react'

type Props = {
  open: boolean
  requiredPixe: string
  currentPixe: string
  shortfallPixe: string
  onClose: () => void
  onBuy: () => void
}

export default function InsufficientPixeModal({
  open,
  requiredPixe,
  currentPixe,
  shortfallPixe,
  onClose,
  onBuy,
}: Props) {
  if (!open) return null
  return (
    <div className="fixed inset-0 z-[90] flex items-center justify-center bg-black/70 p-4" role="dialog" aria-modal="true" aria-label="Publish requires PIXE">
      <div className="w-full max-w-md rounded-2xl border border-white/10 bg-[#0b0b0f] p-4">
        <h3 className="text-lg font-semibold text-white">Publish requires PIXE</h3>
        <p className="mt-2 text-sm text-white/80">Publishing costs {requiredPixe} PIXE per post.</p>
        <p className="mt-1 text-sm text-white/70">Your balance: {currentPixe} PIXE</p>
        <p className="mt-1 text-sm text-white/70">You need {shortfallPixe} PIXE more.</p>
        <div className="mt-4 flex items-center gap-2">
          <button
            type="button"
            onClick={onBuy}
            className="inline-flex min-h-11 items-center justify-center rounded-lg bg-brand px-4 py-2 text-sm font-semibold text-white hover:bg-brand-600"
          >
            Buy PIXE
          </button>
          <button
            type="button"
            onClick={onClose}
            className="inline-flex min-h-11 items-center justify-center rounded-lg border border-white/15 px-4 py-2 text-sm font-semibold text-white/90 hover:bg-white/5"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  )
}

